export default "__VITE_ASSET__LHqmr59w__ 150w, __VITE_ASSET__Fgb1VI0f__ 300w, __VITE_ASSET__Chs3APnQ__ 450w";